import { useQuery } from 'react-query'
import request from 'services/axios'
import { IGuarantorOption } from 'components/modals/guarantorPicker'

/**
 * The borrower's ضامن عضویت, offered as the first option in the loan's
 * guarantor picker.
 *
 * Funds record this when a member joins (7.5k members already have one) and it
 * is overwhelmingly the same person who ends up backing their loan, so pinning
 * it to the top saves the manager scrolling a 900-member list. It is only ever
 * a suggestion — nothing is attached until the manager confirms, and the
 * backend never auto-fills it either.
 */
export default function useGuarantorSuggestion(
    moneypoolId: string | undefined,
    poolshipId: number | undefined
) {
    const { data } = useQuery(
        ['guarantor-suggestion', moneypoolId, poolshipId],
        async () => {
            const { data } = await request.get<{
                guarantor?: {
                    id: number
                    member?: { first_name?: string; last_name?: string }
                } | null
            }>(`/api/v1/moneypools/${moneypoolId}/poolships/${poolshipId}/`)
            return data
        },
        { enabled: !!moneypoolId && !!poolshipId }
    )

    const guarantor = data?.guarantor
    if (!guarantor?.id) {
        return null
    }

    const suggestion: IGuarantorOption = {
        poolship_id: guarantor.id,
        name: `${guarantor.member?.first_name ?? ''} ${
            guarantor.member?.last_name ?? ''
        }`.trim(),
    }
    return suggestion
}
